<template>
  <div class="container">
    <TopGradientBlockLayout class="mb-12">
      <div class="flex items-center">
        <div class="text-text text-lg" v-html="inviteText"></div>
        <BaseButton class="ml-auto mr-4" theme="green" @click="accept(invite.id)">{{ $t('accept') }}</BaseButton>
        <BaseButton theme="red" @click="decline(invite.id)">{{ $t('decline') }}</BaseButton>
      </div>
    </TopGradientBlockLayout>
  </div>
</template>

<script>
import {mapActions, mapMutations} from "vuex";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import BaseButton from "@/components/UI/BaseButton";

export default {
  name: "InviteAlert",
  components: {BaseButton, TopGradientBlockLayout},
  props: {
    invite: {
      type: Object,
      required: true
    }
  },
  computed: {
    inviteText() {
      return this.$t('youHaveInviteFrom', {
        username: this.invite.author.username || this.invite.author.email,
        space: this.invite.space.title
      })
    }
  },
  methods: {
    ...mapActions('space', ['getActiveSpaces']),
    ...mapActions('cabinet/invitations', ['acceptInvite', 'declineInvite']),
    ...mapMutations('cabinet/invitations', ['removeInviteById']),
    accept(id) {
      this.acceptInvite(id).then(res => {
        if (res.body.success) {
          this.removeInviteById(id);
          this.getActiveSpaces();
        }
      })
    },
    decline(id) {
      this.declineInvite(id).then(res => {
        if (res.body.success) {
          this.removeInviteById(id);
          this.getActiveSpaces();
        }
      });
    }
  },
  i18n: {
    messages: {
      en: {
        youHaveInviteFrom: '<span class="font-bold">{username}</span> invites you to the workspace <span class="font-bold">{space}</span>',
        accept: 'Accept',
        decline: 'Decline'
      },
      ru: {
        youHaveInviteFrom: '<span class="font-bold">{username}</span> приглашает вас в пространство <span class="font-bold">{space}</span>',
        accept: 'Принять',
        decline: 'Отклонить'
      }
    }
  }
}
</script>
